export default "__VITE_ASSET__vB98JAyk__"